import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

const Stepper = ({ steps, currentStep, onStepPress }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1 }}>
      {steps.map((step, index) => (
        <Tooltip key={index} title={step.title || step.name}>
          <Box
            onClick={() => onStepPress(index)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 12,
              fontWeight: currentStep === index ? 'bold' : 'normal',
              width: 28,
              height: 28,
              borderRadius: '50%',
              cursor: 'pointer',
              border: '1px solid',
              borderColor: currentStep === index ? 'primary.main' : 'grey.400',
              backgroundColor: currentStep === index ? 'primary.light' : 'background.paper',
              color: currentStep === index ? 'primary.contrastText' : 'text.secondary',
              '&:hover': {
                backgroundColor: currentStep === index ? 'primary.dark' : 'grey.200'
              }
            }}
          >
            <Typography variant="body2">{index + 1}</Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

export default Stepper;
